module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_inomemado@3x-e03631a2747d116ec77404a4f3745962.webp";